export default "__VITE_ASSET__Bd19Msq6__"